import(/* webpackMode: "eager" */ "/codebuild/output/src2163433464/src/app/src/v2/views/partners/auth/forgot-password/ResetPasswordView.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2163433464/src/app/src/v2/views/partners/auth/login/PartnerLogin.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2163433464/src/app/src/v2/views/partners/PartnersLanding/PartnersLandingPage.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2163433464/src/app/src/v2/views/partners/partnersSIgnup/PartnersSignup.tsx");
